import React, { type HTMLAttributes, type ReactNode } from "react";
import { BaseInputV2AdornmentContext } from "src/components/BaseInputV2/BaseInputV2AdornmentContext.tsx";

export const EndAdornment = ({
  endAdornment,
  disabled = false,
  isButton,
  ...rest
}: {
  endAdornment: ReactNode;
  disabled?: boolean;
  isButton?: boolean;
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      onClick={(e) => {
        if (!isButton) {
          e.stopPropagation();
        }
      }}
      {...rest}
    >
      <BaseInputV2AdornmentContext.Provider
        value={{
          disabled,
          position: "end",
        }}
      >
        {endAdornment}
      </BaseInputV2AdornmentContext.Provider>
    </div>
  );
};
